module.exports = __webpack_public_path__ + "c40cf5cc1bc220c0202764935fb537e1.pdf";